const Analytics = {
  triggerEvent(event, parameters, fbqEvent, fbqEventId) {
    if (
      process.env.NODE_ENV === "production" &&
      typeof window !== "undefined"
    ) {
      window.fbq("track", fbqEvent, {}, { eventID: fbqEventId })
      window.gtag("event", event, parameters)
    }

    return true
  },
}

export default Analytics
